import { CartLineItem, CartLineItemsData } from 'domains/cartDomain';
import api from 'utils/api';

const cartService = {
  getItems: (cartId: number) => {
    return api.get<CartLineItemsData>(`/carts/${cartId}`);
  },

  moveToOrderLater: (cartId: number, jobId: number) => {
    return api.put<CartLineItemsData>(`/carts/${cartId}/order-later/${jobId}`);
  },

  moveToOrderNow: (cartId: number, jobId: number) => {
    return api.put<CartLineItemsData>(`/carts/${cartId}/order-now/${jobId}`);
  },

  removeItem: (cartId: number, jobId: number) => {
    return api.delete<CartLineItemsData>(`/carts/${cartId}/${jobId}`);
  },

  changeQuantity: async (payload: Partial<CartLineItem>) => {
    return api.put(
      `/jobs/${payload.jobId}/quantity/update?quantity=${payload.quantity}`
    );
  },
};

export default cartService;
